<p-toast [style]="{marginTop: '80px'}"></p-toast>

<div class="vendor-edit-container" *ngIf="!loading; else loadingTpl">
  <div class="vendor-edit-header">
    <h2>{{isNew ? 'New Vendor' : 'Edit Vendor'}}</h2>
  </div>

  <form [formGroup]="form">

    <!-- IDENTITY -->
    <p-fieldset legend="Identity" [toggleable]="false" styleClass="vendor-section">
      <div class="p-fluid p-formgrid p-grid">
        <div class="p-field p-col-12 p-md-6">
          <label>Name <span class="required">*</span></label>
          <input pInputText formControlName="name" type="text" [class.ng-invalid]="isFieldInvalid('name')" />
          <small class="p-error" *ngIf="isFieldInvalid('name')">Name is required.</small>
        </div>
        <div class="p-field p-col-12 p-md-6">
          <label>Legal Name</label>
          <input pInputText formControlName="legalName" type="text" />
        </div>
        <div class="p-field p-col-12 p-md-4">
          <label>Primary Contact Name</label>
          <input pInputText formControlName="primaryContactName" type="text" />
        </div>
        <div class="p-field p-col-12 p-md-4">
          <label>Primary Contact Email</label>
          <input pInputText formControlName="primaryContactEmail" type="email"
            [class.ng-invalid]="isFieldInvalid('primaryContactEmail')" />
          <small class="p-error" *ngIf="isFieldInvalid('primaryContactEmail')">Enter a valid email.</small>
        </div>
        <div class="p-field p-col-12 p-md-4">
          <label>Primary Contact Phone</label>
          <input pInputText formControlName="primaryContactPhone" type="text" />
        </div>
      </div>
    </p-fieldset>

    <!-- ADDRESS -->
    <p-fieldset legend="Address" [toggleable]="true" [collapsed]="false" styleClass="vendor-section">
      <div class="p-fluid p-formgrid p-grid">
        <div class="p-field p-col-12 p-md-6">
          <label>Address Line 1</label>
          <input pInputText formControlName="addressLine1" type="text" />
        </div>
        <div class="p-field p-col-12 p-md-6">
          <label>Address Line 2</label>
          <input pInputText formControlName="addressLine2" type="text" />
        </div>
        <div class="p-field p-col-12 p-md-3">
          <label>City</label>
          <input pInputText formControlName="city" type="text" />
        </div>
        <div class="p-field p-col-12 p-md-3">
          <label>State / Province</label>
          <input pInputText formControlName="stateOrProvince" type="text" />
        </div>
        <div class="p-field p-col-12 p-md-3">
          <label>Postal Code</label>
          <input pInputText formControlName="postalCode" type="text" />
        </div>
        <div class="p-field p-col-12 p-md-3">
          <label>Country</label>
          <input pInputText formControlName="country" type="text" maxlength="2" />
        </div>
      </div>
    </p-fieldset>

    <!-- TAX + COMPLIANCE -->
    <p-fieldset legend="Tax &amp; Compliance" [toggleable]="true" [collapsed]="false" styleClass="vendor-section">
      <div class="p-fluid p-formgrid p-grid">
        <div class="p-field p-col-12 p-md-4">
          <label>Tax ID (EIN/SSN)</label>
          <input pInputText formControlName="taxId" type="text"
            placeholder="Enter full Tax ID — only last 4 shown in summary" />
          <small>Stored encrypted. {{maskedTaxId ? 'Preview: ' + maskedTaxId : ''}}</small>
        </div>
        <div class="p-field p-col-12 p-md-4" style="padding-top:1.5rem">
          <p-checkbox formControlName="w9OnFile" [binary]="true" label="W-9 On File"></p-checkbox>
        </div>
        <div class="p-field p-col-12 p-md-4" style="padding-top:1.5rem">
          <p-checkbox formControlName="is1099Required" [binary]="true" label="1099 Required"></p-checkbox>
        </div>
      </div>
    </p-fieldset>

    <!-- CLASSIFICATION -->
    <p-fieldset legend="Classification" [toggleable]="true" [collapsed]="false" styleClass="vendor-section">
      <div class="p-fluid p-formgrid p-grid">
        <div class="p-field p-col-12 p-md-6">
          <label>Region</label>
          <p-dropdown [options]="regionOptions" formControlName="region"
            optionLabel="label" optionValue="value" appendTo="body">
          </p-dropdown>
        </div>
        <div class="p-field p-col-12 p-md-6">
          <label>Vendor Type</label>
          <p-dropdown [options]="vendorTypeOptions" formControlName="vendorType"
            optionLabel="label" optionValue="value" appendTo="body">
          </p-dropdown>
        </div>
      </div>
    </p-fieldset>

    <!-- PAYMENT -->
    <p-fieldset legend="Payment" [toggleable]="true" [collapsed]="false" styleClass="vendor-section">
      <div class="p-fluid p-formgrid p-grid">
        <div class="p-field p-col-12 p-md-4">
          <label>Payment Method</label>
          <p-dropdown [options]="paymentOptions" formControlName="paymentMethod"
            optionLabel="label" optionValue="value" appendTo="body">
          </p-dropdown>
        </div>
        <div class="p-field p-col-12 p-md-4">
          <label>ACH Routing Number (9 digits)</label>
          <input pInputText formControlName="achRoutingNumber" type="text"
            [class.ng-invalid]="isFieldInvalid('achRoutingNumber')" maxlength="9" />
        </div>
        <div class="p-field p-col-12 p-md-4">
          <label>ACH Account Number</label>
          <p-password formControlName="achAccountNumberEncrypted"
            [feedback]="false" [toggleMask]="true"></p-password>
        </div>
        <div class="p-field p-col-12 p-md-4">
          <label>Payment Terms (Net N Days)</label>
          <p-inputNumber formControlName="paymentTermsDays" [min]="0" [max]="365"></p-inputNumber>
        </div>
      </div>
    </p-fieldset>

    <!-- EXTERNAL REFS -->
    <p-fieldset legend="External References" [toggleable]="true" [collapsed]="true" styleClass="vendor-section">
      <div class="p-fluid p-formgrid p-grid">
        <div class="p-field p-col-12 p-md-6">
          <label>QuickBooks Vendor Ref</label>
          <input pInputText formControlName="qbVendorRef" type="text" />
        </div>
        <div class="p-field p-col-12 p-md-6">
          <label>Default Rate Card ID (OrderProduct ID)</label>
          <input pInputText formControlName="defaultRateCardId" type="number" />
        </div>
      </div>
    </p-fieldset>

    <!-- STATUS -->
    <p-fieldset legend="Status" [toggleable]="true" [collapsed]="false" styleClass="vendor-section">
      <div class="p-fluid p-formgrid p-grid">
        <div class="p-field p-col-12 p-md-3" style="padding-top:1rem">
          <p-inputSwitch formControlName="isActive"></p-inputSwitch>
          <label style="margin-left:0.5rem">{{form.get('isActive').value ? 'Active' : 'Inactive'}}</label>
        </div>
        <div class="p-field p-col-12 p-md-3" *ngIf="isInactive">
          <label>Deactivated Date</label>
          <p-calendar formControlName="deactivatedDate" dateFormat="mm/dd/yy" appendTo="body"></p-calendar>
        </div>
        <div class="p-field p-col-12 p-md-6" *ngIf="isInactive">
          <label>Deactivation Reason</label>
          <textarea pInputTextarea formControlName="deactivationReason" rows="2"></textarea>
        </div>
      </div>
    </p-fieldset>

    <!-- NOTES -->
    <p-fieldset legend="Notes" [toggleable]="true" [collapsed]="false" styleClass="vendor-section">
      <div class="p-fluid">
        <div class="p-field">
          <textarea pInputTextarea formControlName="notes" rows="4" style="width:100%"></textarea>
        </div>
      </div>
    </p-fieldset>

  </form>
</div>

<ng-template #loadingTpl>
  <div style="text-align:center; padding:3rem;">
    <p-progressSpinner></p-progressSpinner>
  </div>
</ng-template>

<!-- Sticky footer -->
<div class="vendor-edit-footer">
  <button pButton pRipple class="p-button-secondary p-button-outlined"
    label="Cancel" (click)="onCancel()">
  </button>
  <button pButton pRipple class="p-button btn-blue"
    label="Save" [loading]="saving" (click)="onSave()"
    [disabled]="saving">
  </button>
</div>
